import React, { useContext, useState, useEffect } from 'react'
import { Link, useNavigate } from "react-router-dom";
import $ from 'jquery';
import { toast } from 'react-toastify'
import { global } from '../../Context/Context';
import axiosInstance from '../../config/axiosInterceptor';

const EditUserBadge = () => {
    const [type, setType] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [svgaName, setSvgaName] = useState("");
    const [imageName, setImageName] = useState("");

    const { fetchuserBadge, fetchuserBadgeS } = useContext(global)
    // An item that belongs to a VIP pack: its type, price and validity are
    // dictated by the VIP, so they're shown read-only here.
    const vipId = fetchuserBadgeS?.vipId || null;
    useEffect(() => {
        if (fetchuserBadgeS && fetchuserBadgeS.type) {
            setType(fetchuserBadgeS.type);
        }
    }, [fetchuserBadgeS]);

    useEffect(() => {
        const queryString = window.location.search;
        const params = new URLSearchParams(queryString);
        const id = params.get('id');

        $('#form')[0].reset();
        fetchuserBadge(id);
    }, []);

    const navigate = useNavigate();

    const subbbb = async (e) => {
        e.preventDefault();
        if (submitting) return;
        var a = vipId ? fetchuserBadgeS.type : $("select[name='type']").val();
        var b = $("input[name='title']").val();
        // For a VIP item these are fixed by the VIP, so resend the saved values
        // rather than reading inputs that aren't editable (or rendered).
        var c = vipId ? fetchuserBadgeS.price : $("input[name='price']").val();
        var d = vipId ? fetchuserBadgeS.valid : $("input[name='valid']").val();
        var id = $("input[name='id']").val();
        var e = $("input[name='svga']")[0].files[0];
        var f = $("input[name='image']")[0].files[0];

        let formData = new FormData();
        formData.append('type', a);
        formData.append('title', b);
        formData.append('price', c);
        formData.append('valid', d);
        formData.append('id', id);
        // The backend does `vipId: req.body.vipId || null`, so omitting this
        // would silently unlink the item from its VIP.
        if (vipId) formData.append('vipId', vipId);
        if (e) formData.append('svga', e);
        if (f) formData.append('image', f);

        setSubmitting(true);

        await axiosInstance.post(`${process.env.REACT_APP_BASEURL5}/admin/userBadge/updateuserbadge`, formData).then((res) => {
            if (res.data.success === 1) {
                toast.success(res.data.message)
                setTimeout(() => {
                    navigate(vipId ? `/admin/viewVipPack?id=${vipId}` : '/admin/manageUserBadge')
                }, 2000)
            } else {
                toast.error(res.data.message)
                setSubmitting(false);
            }
        }).catch((e) => { toast.error(e.message); setSubmitting(false); });
    }

    return (
        <>
            <section className="content-header">
                <h1>Edit User Badge</h1>
                <ol className="breadcrumb">
                    <li><Link to="/admin"><i className="fa fa-dashboard"></i> Home</Link></li>
                    <li><Link to="/admin/manageUserBadge">Manage User Badge</Link></li>
                    <li className="active">Edit User Badge</li>
                </ol>
            </section>
            <section className="content">
                <div className="row">
                    <div className="col-md-12">
                        <form role="form" method="post" onSubmit={subbbb} encType="multipart/form-data" id='form'>
                            <div className="box box-warning">
                                <div className="box-header with-border">
                                    <h3 className="box-title">Edit</h3>
                                </div>
                                <div className="box-body">
                                    <input type="hidden" name='id' defaultValue={fetchuserBadgeS._id} />
                                    <div className="form-group">
                                        <label>Type*</label>
                                        <select
                                            className="form-control"
                                            name="type"
                                            value={type}
                                            disabled={!!vipId}
                                            onChange={e => setType(e.target.value)}
                                        >
                                            <option value="">Select Type</option>
                                            <option value="PLAN">PLAN</option>
                                            <option value="PURCHASED">PURCHASED</option>
                                            <option value="VIP">VIP</option>
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label>Title*</label>
                                        <input type="text" className="form-control" name="title" placeholder="Title" defaultValue={fetchuserBadgeS.title} />
                                    </div>
                                    {!vipId && (
                                        <div className="form-group">
                                            <label>Price*</label>
                                            <input type="number" className="form-control" name="price" placeholder="price" defaultValue={fetchuserBadgeS.price} />
                                        </div>
                                    )}
                                    <div className="form-group">
                                        <label>Valid {type === "PLAN" ? "Hours" : "Days"}*</label>
                                        {vipId ? (
                                            <>
                                                <input type="number" className="form-control" value={fetchuserBadgeS.valid || ""} readOnly disabled />
                                                <small className="text-muted">Inherited from the VIP - all items expire with it.</small>
                                            </>
                                        ) : (
                                            <input type="number" className="form-control" name="valid" placeholder={`valid ${type === "PLAN" ? "hours" : "days"}`} defaultValue={fetchuserBadgeS.valid} />
                                        )}
                                    </div>
                                    <div className="form-group">
                                        <label>Svga</label>
                                        <input type="file" className="form-control" name="svga" onChange={(e) => {
                                            setSvgaName(e.target.files[0] ? e.target.files[0].name : "");
                                        }} />
                                        {svgaName && <div className="text-success"><i className="fa fa-check"></i> {svgaName} attached</div>}
                                    </div>
                                    <div className="form-group">
                                        <label>Image</label>
                                        <input type="file" className="form-control" name="image" onChange={(e) => {
                                            setImageName(e.target.files[0] ? e.target.files[0].name : "");
                                        }} />
                                        {imageName && <div className="text-success"><i className="fa fa-check"></i> {imageName} attached</div>}
                                    </div>
                                    <div className="form-group">
                                        <label>Old Icon</label><br />
                                        <img src={fetchuserBadgeS.image} alt="" height={"80px"} />
                                    </div>
                                    <div className="form-group">
                                        <button type="button" className="btn btn-default" onClick={() => {
                                            $("#form")[0].reset();
                                            setType(fetchuserBadgeS.type || "");
                                            setSvgaName("");
                                            setImageName("");
                                        }}>Reset</button>{" "}
                                        <button type="button" className="btn btn-danger" onClick={() => navigate(vipId ? `/admin/viewVipPack?id=${vipId}` : '/admin/manageUserBadge')}>Cancel</button>
                                        <button type="submit" className="btn btn-success pull-right" name="submit" disabled={submitting}>{submitting ? (<><i className="fa fa-spinner fa-spin mr-1" /> Saving...</>) : ("Submit")}</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
        </>
    )
}

export default EditUserBadge
